import { Component, OnInit } from '@angular/core';
import { Errors, FormSessionCanDeactivate, UserService } from '../shared';
import { ActivatedRoute, Resolve,Router, RouterStateSnapshot } from '@angular/router';
import { environment } from '../shared/config/app-config';
import { User } from '../shared';
@Component({
  selector: 'app-patienthome',
  templateUrl: './patienthome.component.html',
  styleUrls: ['./patienthome.component.css']
})
export class PatienthomeComponent extends FormSessionCanDeactivate {
  imageURL: string = environment.cloudeImageURL;
  resp:any;
  currentUser: User; 
  public apiurl:any = environment.api_url;
  public parenetshow:boolean=false;
  constructor(
    private userService:UserService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    //////console.log(this.route.snapshot.url[0].path);
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        this.currentUser.status = false;
        
      }
    )
    if(this.currentUser.item.hostModel=="CLOUD")
    this.imageURL = environment.cloudeImageURL;
  else   
    this.imageURL = environment.vmImageURL;

    if(this.route.snapshot.url[0].path == 'home'){
      this.currentUser.operationMessage = 'Select CarePath'
    }

    this.userService
    .postuserinfoid('1',this.currentUser.item.userAccountId)
    .subscribe(
      data => {
        this.resp = data; 
        // ////console.log(this.resp);
      }
    );
  }
  setdata(workflow){
    this.userService.setUser(workflow);
   
    
  }
  
}
